const namespace = 'EventDetail';

// Event Detail
export const REQUEST_EVENT_DETAIL = `${namespace}/REQUEST_EVENT_DETAIL`;
export const RECEIVE_EVENT_DETAIL_SUCCESS = `${namespace}/RECEIVE_EVENT_DETAIL_SUCCESS`;
export const RECEIVE_EVENT_DETAIL_ERROR = `${namespace}/RECEIVE_EVENT_DETAIL_ERROR`;

// Current event id
export const SET_CURRENT_EVENT_ID = `${namespace}/SET_CURRENT_EVENT_ID`;
